// extracted by mini-css-extract-plugin
var _1 = "UserPopup_icon__H78Sm";
var _2 = "UserPopup_menu__p4l23";
var _3 = "UserPopup_menuItem__BsTm8";
export { _1 as "icon", _2 as "menu", _3 as "menuItem" }
